import {Component, Input, OnInit} from '@angular/core';
import {MyDialogDataModel} from '../../../models/my-dialog-data.model';
import {EditModalService} from '../../../services/edit-modal.service';
import {MyContainersTableIdEnum} from '../../../enums/my-containers-table-id.enum';
import {ControlContainer, NgForm} from '@angular/forms';
import {ProjectUpdateNotificationFieldEnum} from '../../../enums/project-update-notification-field.enum';

@Component({
    selector: 'app-project-services-table',
    templateUrl: './project-services-table.component.html',
    styleUrls: ['./project-services-table.component.scss'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class ProjectServicesTableComponent implements OnInit {

    public model: MyDialogDataModel;

    @Input() isViewerMode = false;

    @Input() public forceFormValidationVisibility: boolean;
    public ProjectUpdateNotificationFieldEnum = ProjectUpdateNotificationFieldEnum;


    constructor(
        private editModalService: EditModalService,
    ) {
    }

    ngOnInit() {
        this.model = this.editModalService.getDialogModel();
    }

    public onRemoveServicesFromOrderBtnLicked() {
        this.model.isServiceOrderRequested = false;
        this.editModalService.announceTableContentChanged(MyContainersTableIdEnum.step4ServicesContainers);
    }

    public notifyChange(fieldId: ProjectUpdateNotificationFieldEnum): boolean {
        return this.editModalService.showChangeNotification(fieldId);
    }

    public onAddServiceBtnClicked() {
        this.model.isServiceDescriptionActive = true;
    }

    public projectRowItemsAmountComplyRules() {
        return true;
    }

    public isAddServiceBtnVisible(): boolean {
        return !this.isServiceDescriptionActive();
    }


    public isServiceDescriptionActive(): boolean {
        return this.model.isServiceDescriptionActive;
    }
}
